export const config = {
    gaId: process.env.GA_ID || null,
    apiBase: process.env.API_BASE || null,
};
